var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroLayoutNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "10px",
    viewBox: "0 0 18 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hero_layout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hero_layout",
    fill: "#727272",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,0 L10,10 L0,10 L0,0 Z M12,0 L14,0 L14,2 L12,2 L12,0 Z M12,4 L14,4 L14,6 L12,6 L12,4 Z M12,8 L14,8 L14,10 L12,10 L12,8 Z M16,0 L18,0 L18,2 L16,2 L16,0 Z M16,4 L18,4 L18,6 L16,6 L16,4 Z M16,8 L18,8 L18,10 L16,10 L16,8 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLayoutNew);
export default __webpack_public_path__ + "static/media/Hero_layout_new.82a75b5a3bfb2ca7e04229341074a139.svg";
export { ForwardRef as ReactComponent };